/** Nombres en español de los roles de usuario (#13893): nunca el valor crudo en pantalla. */
export const USER_TYPE: Record<string, string> = {
	ADMIN: "Administración",
	ADMIN_BILLING: "Facturación",
	ADMIN_CONTROLLING: "Control de gestión",
	ADMIN_EMPLOYEE: "RR. HH.",
	ADMIN_RECRUITMENT: "Selección",
	ADMIN_PROJECT: "Proyectos",
	ADMIN_MARKETING: "Marketing",
	ADMIN_ACCOUNTING: "Contabilidad",
	ADMIN_COMPLIANCE: "Compliance",
	EMPLOYEE: "Empleado",
	PUBLIC: "Público",
};
